export default __webpack_public_path__ + "static/media/500_2 1.4efbf892.svg";